import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Select,
  InputNumber,
  message,
  Spin,
  Card,
  Space,
  Row,
  Col,
  Divider,
  Switch,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import TinyEditor from "../../components/Editor";

const { TextArea } = Input;

const AddCarrier = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [editorContent, setEditorContent] = useState("");

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const formData = new FormData();

      const appendIfExists = (key, value) => {
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      };

      appendIfExists("name", values.name);
      appendIfExists("price", values.price);
      appendIfExists("limit", values.limit);

      
      formData.append("body", editorContent);

      const response = await api.post("/panel/carrier", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("حامل با موفقیت اضافه شد.");
      navigate("/carrier");
    } catch (error) {
      message.error("خطا در ارسال اطلاعات.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <div>
        <h2 className="mb-10 text-xl">افزودن حامل</h2>
        <Spin spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="name"
              label="عنوان"
              rules={[
                {
                  required: true,
                  message: "لطفاً عنوان را وارد کنید.",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="price"
                  label="قیمت"
                  rules={[
                    {
                      required: true,
                      message: "لطفاً پیوند را وارد کنید.",
                    },
                  ]}
                >
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="limit"
                  label="محدودیت قیمت سفارش"
                  rules={[
                    {
                      required: true,
                      message: "لطفاً محدودیت قیمت را وارد کنید.",
                    },
                  ]}
                >
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="محتوا"
              validateTrigger={["onChange", "onBlur"]}
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    if (!editorContent) {
                      return Promise.reject("لطفاً محتوا را وارد کنید.");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <TinyEditor
                content={editorContent}
                onEditorChange={handleEditorChange}
                model={"Category"}
                height={300}
              />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" loading={loading}>
                  ذخیره
                </Button>
                <Button
                  onClick={() => navigate("/carrier")}
                  style={{ marginRight: "8px" }}
                >
                  انصراف
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </Card>
  );
};

export default AddCarrier;
